import * as actionTypes from '../actionTypes';
import axios from '../../../_services/api/axios';

/* ------------------ Design Upload ------------------- */
export const helpersDesignuploadStart = () => {
    return {
        type: actionTypes.HELPERS_DESIGNUPLOAD_START
    };
};

export const helpersDesignuploadSuccess = (details) => {
    return {
        type: actionTypes.HELPERS_DESIGNUPLOAD_SUCCESS,
        details: details
    };
};

export const helpersDesignuploadFail = ( error ) => {
    return {
        type: actionTypes.HELPERS_DESIGNUPLOAD_FAIL,
        error: error
    };
};

export const helpersDesignuploadProgress = ( progressEvent ) => {
    return {
        type: actionTypes.HELPERS_DESIGNUPLOAD_PROGRESS,
        percent: Math.round( (progressEvent.loaded * 100) / progressEvent.total )
    };
};

export const helpersDesignuploadReset = ( ) => {
    return {
        type: actionTypes.HELPERS_DESIGNUPLOAD_RESET
    };
};

export const helpersDesignupload = (formData) => {
    return dispatch => {
        dispatch(helpersDesignuploadStart());
        axios.post( '/production/calculator/designs/metadata', formData, {
                headers: {
                    'Content-type': 'multipart/form-data'
                },
                onUploadProgress: function(progressEvent) {
                    dispatch( helpersDesignuploadProgress( progressEvent ) )
                }
            })
            .then( response => {
                dispatch( helpersDesignuploadSuccess( response.data ) );
            } )
            .catch( error => {
                dispatch( helpersDesignuploadFail( error ) );               
            } );
    };
};


// WEBPACK FOOTER //
// ./src/_store/actions/helpers/design.js